import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

const InfluencerRedirect = () => {
  const { slug } = useParams();

  useEffect(() => {
    if (slug) {
      window.location.replace(`/api/v1/i/${encodeURIComponent(slug)}`);
    }
  }, [slug]);

  return (
    <main style={{ minHeight: "60vh", display: "grid", placeItems: "center", padding: 24 }}>
      <p>Redirecting...</p>
    </main>
  );
};

export default InfluencerRedirect;
